import React from 'react';
// import PropTypes from 'prop-types';
import { PsPage } from '../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../i18n/I18nUtils';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as typeDocumentsActions from '../actions/typeDocumentsActions';
import { TypeDocumentsEditFormCard } from '../components/TypeDocumentsFormCard';
import { BreadcrumbsManagerInstance } from '../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../shared/breadcrumbs/Breadcrumbs';

class TypeDocumentDetailScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_OUTSOURCES,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_TYPES,
            Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_TYPES_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    componentDidMount() {
        const { id } = this.props.match.params;
        this.props.typeDocumentsActions.getTypeDocument(id);
    }

    componentDidUpdate(prevProps) {
        const { document: currentDocument, location } = this.props;
        const { document: prevDocument } = prevProps;

        if ( currentDocument !== prevDocument && currentDocument ) {
            BreadcrumbsManagerInstance.finishLoading({
                id: Breadcrumbs.MY_OUTSOURCES_DOCUMENTS_TYPES_DETAIL.id,
                url: location.pathname,
                description: currentDocument.name,
            });

            this.setState({
                breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
            });
        }
    }

    render() {
        const { document } = this.props;
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MI_TIPO_DE_DOCUMENTO')} breadcrumbs={breadcrumbs}>
                {
                    document ? (
                        <TypeDocumentsEditFormCard typedocument={document} disabledSchemaTypeField={true}/>
                    ) : null
                }
            </PsPage>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        document: state.typedocuments.typeDocuments[ownProps.match.params.id],
    };
};

const mapDispatchToProps = dispatch => ( {
    typeDocumentsActions: bindActionCreators(typeDocumentsActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(TypeDocumentDetailScreen);

TypeDocumentDetailScreen.propTypes = {};

TypeDocumentDetailScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/documents/screens/TypeDocumentDetailScreen.js